import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import LiveMatches from './components/LiveMatches';
import CategorySection from './components/CategorySection';
import NewsSection from './components/NewsSection';
import PromotionSection from './components/PromotionSection';
import TrustSection from './components/TrustSection';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <LiveMatches />
        <CategorySection />
        <NewsSection />
        <PromotionSection />
        <TrustSection />
      </main>
      <Footer />
      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'WebPage',
          name: '皇冠体育 - 专业体育竞技投注首选',
          description: '皇冠体育是亚洲领先的专业体育竞技平台，覆盖足球、篮球、网球等数百项赛事，提供实时赔率、安全存取款、24小时客服支持。',
          url: 'https://www.huangguan-sports.com/',
        })}
      </script>
      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'FAQPage',
          mainEntity: [
            {
              '@type': 'Question',
              name: '如何注册皇冠体育账号？',
              acceptedAnswer: { '@type': 'Answer', text: '注册皇冠体育账号非常简单。点击页面右上角的"立即注册"按钮，填写手机号码或邮箱地址，设置登录密码，完成短信或邮箱验证后即可成功注册。整个过程仅需1-2分钟。' },
            },
            {
              '@type': 'Question',
              name: '皇冠体育支持哪些存款方式？',
              acceptedAnswer: { '@type': 'Answer', text: '皇冠体育支持多种安全便捷的存款方式，包括银行转账、支付宝、微信支付、USDT数字货币等。所有存款均享受实时到账服务，且不收取任何手续费。' },
            },
            {
              '@type': 'Question',
              name: '提款需要多长时间到账？',
              acceptedAnswer: { '@type': 'Answer', text: '皇冠体育承诺快速提款服务。一般情况下，提款申请提交后5-30分钟内即可到账。大额提款可能需要额外的安全审核，但通常不会超过2小时。我们支持24小时全天候提款服务。' },
            },
            {
              '@type': 'Question',
              name: '皇冠体育的赔率水平如何？',
              acceptedAnswer: { '@type': 'Answer', text: '皇冠体育采用国际领先的赔率体系，在足球、篮球等主流赛事中提供极具竞争力的赔率。我们的赔率团队由资深数据分析师组成，确保赔率既能反映真实概率，又为玩家提供充足的投注价值。' },
            },
            {
              '@type': 'Question',
              name: '手机端可以投注吗？',
              acceptedAnswer: { '@type': 'Answer', text: '当然可以！皇冠体育提供专业的移动端投注体验。您可以通过手机浏览器直接访问皇冠体育官网，也可以下载皇冠体育手机APP，享受更流畅的移动投注服务。移动端功能与电脑端完全同步，随时随地畅享体育博彩。' },
            },
            {
              '@type': 'Question',
              name: '皇冠体育是合法平台吗？',
              acceptedAnswer: { '@type': 'Answer', text: '皇冠体育持有合法的博彩运营牌照，严格遵守国际博彩行业规范。我们采用SSL加密技术和严格的资金隔离制度，确保用户信息和资金安全。平台运营15年以上，服务超过500万用户，信誉有保障。' },
            },
          ],
        })}
      </script>
    </>
  );
}